module.exports = __webpack_public_path__ + "media/images/forms-icons/date-icon-hover-a8e75097d9eb6ed8f4a703fd60e9e2dd.svg";